import { useCallback } from "react";
import {
  type BrushRange,
  useAnalysisStore,
} from "@/stores/useAnalysisStore";

export function useChartInteraction() {
  const selectedFeature = useAnalysisStore((s) => s.selectedFeatureId);
  const selectedRT = useAnalysisStore((s) => s.selectedRT);
  const brushRange = useAnalysisStore((s) => s.brushRange);

  // Zustand action references are stable across renders — no re-creation
  const handleFeatureSelect = useAnalysisStore((s) => s.toggleFeature);
  const handleMZRTClick = useAnalysisStore((s) => s.selectMZRT);
  const setBrushRange = useAnalysisStore((s) => s.setBrushRange);
  const handleClearBrush = useAnalysisStore((s) => s.clearBrush);
  const setSelectedRT = useAnalysisStore((s) => s.setSelectedRT);

  // 2026-09-03: 브러시 좌표를 **RT 도메인**으로 받는다(종전 배열 인덱스).
  // 인덱스는 TIC 배열이 어떻게 만들어졌는지에 따라 의미가 바뀌어, 표시
  // 해상도를 손대는 순간 같은 숫자가 다른 구간을 가리켰다.
  // uPlot 은 확대할 때마다 RT 범위를 주므로 throttle 이 필요 없다 — 스케일
  // 변경은 드래그 종료 시 1회다(종전 recharts Brush 는 마우스 이동마다 쐈다).
  const handleTICZoom = useCallback(
    (range: BrushRange | null) => {
      setBrushRange(range);
    },
    [setBrushRange],
  );

  return {
    selectedFeature,
    selectedRT,
    brushRange,
    handleFeatureSelect,
    handleMZRTClick,
    handleTICZoom,
    handleClearBrush,
    setSelectedRT,
  };
}
